import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { NavigationService } from '../../services/navigation.service';

@Component({
    selector: 'app-container',
    templateUrl: './container.component.html',
    imports: [NgTemplateOutlet, NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContainerComponent {
  @Input() sidebar = false;
  @Input() subpage = false;

  constructor(private navigationService: NavigationService) {}

  goBack() {
    this.navigationService.back();
  }
}
